import React, {useState} from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form, {DEFAULT_REPLACEMENT_REASON, formatReplacementReason} from "./ReplacePackagesForShippingOrderForm";
import {cancelChangeReplacementReason} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";


const ChangeReplacementReason = (props) => {
  const [errors, setErrors] = useState([]);

  const currentReason = props.currentReason;

  function handleSubmit(data) {
    const updatedValues = {
      orderId: props.orderId,
      packageIds: props.packageIds,
      replacementReason: data.get("replacementReason"),
    }

    return props.changeReplacementReason(updatedValues)
      .then((response) => {
        if (response.data.changeReplacementReason.errors.length > 0) {
          const errors = createValidationErrors(response.data.changeReplacementReason.errors);
          setErrors(errors);
        } else {
          handleCancel();
        }
      })
      .catch((err) => {
        setErrors(createErrors(err));
      });
  }

  function handleCancel() {
    props.cancelChangeReplacementReason();
  }

  const message = !currentReason
    ? `Set the reason for replacing the package(s) ${props.packageIds.join(", ")}.`
    : `Update the reason for the package(s) "${props.packageIds.join(", ")}". Current reason: "${formatReplacementReason(currentReason)}".`;

  return (
    <Form
      errors={errors}
      message={message}
      initialValues={{replacementReason: DEFAULT_REPLACEMENT_REASON}}
      submitLabel={currentReason ? "Change Reason" : "Set Reason"}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  );
}


const CHANGE_REPLACEMENT_REASON = gql`
  mutation changeReplacementReason($data: ChangeReplacementReasonInput!) {
    changeReplacementReason(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CHANGE_REPLACEMENT_REASON, {
    props: ({ mutate }) => ({
      changeReplacementReason: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelChangeReplacementReason})(withMutation(ChangeReplacementReason));